import ApplicationBaseController from "./application_base_controller.js"

export default class extends ApplicationBaseController {

}
